<template>
  <v-main></v-main>
</template>

<script>
import axios from "axios";
export default {
  created() {
    if (this.$store.getters.loggedIn) {
      axios
        .post(
          this.$store.getters.getAPI + "/logout",
          null,
          this.$store.getters.getAuthHeader
        )
        .then((response) => {
          localStorage.removeItem("token");
          localStorage.removeItem("name");
          this.$store.commit("destroyToken");
            this.$router.push({
              name: "Login",
            });
            this.$store.dispatch('PushSuccessMsg', response.data.message);
        })
        .catch((error) => {
          if (error){
            localStorage.removeItem("token");
            localStorage.removeItem("name");
            this.$store.commit("destroyToken");
            this.$store.dispatch('PushErrorMsg', 'Something went wrong');
          }
        });
    }
  },
};
</script>
